import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getDraftImages } from 'apps/web_forms/api/api';

export const useDraftImages = ({draftId, isDraft}) => {
  const [draftImages, setDraftImages] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isDraft) {
      setLoading(true);
      getDraftImages(draftId).then(data => {
        setDraftImages(data);
        setLoading(false);
      }).catch(err => {
        // TODO: Integrate Bugsnag to log the errors in prod.
        // eslint-disable-next-line no-console
        console.error('There was an error on the request.', err);
        setLoading(false);
        setError(err);
      });
    }
  }, [draftId, isDraft]);

  return { draftImages, loading, error };
};

useDraftImages.propTypes = {
  isDraft: PropTypes.bool.isRequired,
  draftId: PropTypes.string,
};

useDraftImages.defaultProps = {
  isDraft: false,
  draftId: undefined,
};

export default useDraftImages;
